import * as Yup from 'yup';
import { translate } from 'helpers/intl';
import messages from 'containers/SignupPages/CreatePassword/messages';
import { STRONG_PASSWORD_REGEX } from 'containers/PasswordRecoveryPages/constants';

export default (props: any) =>
  Yup.object().shape({
    password: Yup.string()
      .min(10, translate({ ...messages.passwordMsg }, props))
      .matches(STRONG_PASSWORD_REGEX)
      .required(translate({ ...messages.requiredField }, props)),
    confirmPassword: Yup.string()
      .oneOf(
        [Yup.ref('password')],
        translate({ ...messages.confirmPasswordError }, props),
      )
      .required(translate({ ...messages.requiredField }, props)),
    questionSecret: Yup.string().required(
      translate({ ...messages.requiredField }, props),
    ),
    response: Yup.string().required(
      translate({ ...messages.requiredField }, props),
    ),
  });
